























































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import { RecruitService } from "@/zh-website/src/views/Recruit/service";
@Component({
  components: {
    SideBar
  }
})
export default class RecruitSocial extends Vue {
  tableData = [];
  total = 0;
  WorkingPlace: any = [];
  addr = "全部";
  restaurantsList: any = []; //招聘信息列表
  search = "";
  timer;
  page = 1;
  scrollTop;
  mounted() {
    //
    window.addEventListener("scroll", this.scrollToTop);
    this.getWorkingPlace();
    this.recruitList();
  }
  //搜索并记录搜索内容
  searchBtn() {
    this.page = 1;
    this.recruitList();
  }
  //分页
  handleCurrentChange(val) {
    this.goTop2();
    this.recruitList();
    this.page = val;
  }
  //返回顶部
  goTop2() {
    const timer = setInterval(() => {
      const ispeed = Math.floor(-this.scrollTop / 1);
      document.documentElement.scrollTop = document.body.scrollTop =
        this.scrollTop + ispeed;
      if (this.scrollTop === 0) {
        clearInterval(timer);
      }
    }, 16);
  }
  scrollToTop() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.scrollTop = scrollTop;
  }

  //了解更多
  handleClick(row) {
    // console.log(row);
    this.$router.push({ path: "/home/recruit/resume/1/" + row.id });
  }

  //获取工作地点
  getWorkingPlace() {
    //网络请求数据
    RecruitService.getPlaceList({ type: 1 }).then((res: any) => {
      this.WorkingPlace = res.data;
    });
  }

  //获取招聘信息列表  position 职位名称  addr 工作地点 search 搜索内容
  recruitList() {
    //搜索
    RecruitService.getRecruitList({
      pageNum: this.page,
      pageSize: 10,
      keyword: this.search,
      workPlace: this.addr,
      type: 1
    }).then((res: any) => {
      this.restaurantsList = res.data.list;
      this.total = res.data.totalCount;
    });
  }
}
